import React from "react";

import { createClassNameString } from "@/component-library";

import "./CarePlanEmptyContent.styles.scss";

export const CarePlanEmptyContent = ({ containerClassName, text }) => {
  return (
    <div
      className={createClassNameString(["CarePlanEmptyContentCard--container", containerClassName])}
    >
      <p className="CarePlanEmptyContentCard--text">{text}</p>
    </div>
  );
};
